// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 992px) {\n.cart[data-v-0139beee] {\n    padding: 0.45rem;\n}\n}", ""]);
// Exports
module.exports = exports;
